/**
 * Storage API del navegador — dos cosas, ninguna bloqueante ni visible para
 * el usuario en el caso normal:
 *
 * 1. `persist()`: le pedimos al navegador que NO borre el storage de este
 *    sitio (IndexedDB incluido) automaticamente cuando el dispositivo ande
 *    corto de espacio. No es un permiso con popup como camara/ubicacion —
 *    cada navegador decide solo, con sus propios criterios (en Chrome/Edge
 *    normalmente se concede solo si la PWA esta instalada y con uso
 *    reciente; en Safari/iOS es mas impredecible y ademas tiene su propia
 *    politica de purga por inactividad — instalar la app a la pantalla de
 *    inicio ayuda tambien ahi). No es garantia total, es la mejor practica
 *    razonable sin costo.
 *
 * 2. `estimate()`: solo diagnostico, para ver en consola cuanto espacio
 *    tiene realmente asignado este sitio en este dispositivo — util para
 *    confirmar en los celulares reales de la feria si el numero se acerca
 *    a algun limite, en vez de asumirlo.
 */
export async function pedirStoragePersistente(): Promise<void> {
  try {
    if (navigator.storage?.persist) {
      const concedido = await navigator.storage.persist()
      console.info(`[storage] almacenamiento persistente: ${concedido ? 'concedido' : 'no concedido por el navegador'}`)
    }
    if (navigator.storage?.estimate) {
      const { quota, usage } = await navigator.storage.estimate()
      if (quota !== undefined && usage !== undefined) {
        const usadoMB = (usage / (1024 * 1024)).toFixed(1)
        const totalMB = (quota / (1024 * 1024)).toFixed(1)
        console.info(`[storage] uso actual: ${usadoMB} MB de ${totalMB} MB asignados a este sitio`)
      }
    }
  } catch (err) {
    // Puramente informativo — si la API no esta disponible o falla, la app sigue igual.
    console.error('[storage] no se pudo consultar/pedir almacenamiento persistente:', err)
  }
}
